function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 3H3.73499L6.73166 16.7673H19.1961",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M4.42987 5.47552H21.4545L19.7173 12.7283L6.2105 14.2918",
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 8.1969,
  cy: 20.4823,
  r: 0.75,
  stroke: "#627080",
  strokeWidth: 1.5
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 17.6126,
  cy: 20.4823,
  r: 0.75,
  stroke: "#627080",
  strokeWidth: 1.5
});

const SvgCartClassic = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCartClassic, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Cart-classic.e5377cc5.svg";
export { ForwardRef as ReactComponent };